import React, { useState } from "react";
import PT from "prop-types";
import get from "lodash/get";

import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import SocialShareBottom from "../social-share";
import StoryHeader from "../story-header-native-ad";
import StoryCard from "../story-card";
import { SocialShare, Link, LazyLoadImages, EagerLoadImages } from "@quintype/components";
import "./native-ad.m.css";

const NativeAdStory = ({ story }) => {
  const metakeywords = story["seo"]["meta-keywords"];
  const hashtags = metakeywords ? metakeywords.map (item => {
    return item.replace(/ /g, "");
  }) : "";

  return (
    <React.Fragment>
      <div styleName="top-container">
        <div styleName="main-container">
          <div styleName="main">
          </div>
          <div styleName="blank-story">
            <div styleName="sticky-social-share">
              <SocialShare
                template={StickySocialShareTemplate}
                story={story}
                title={story.headline}
                url={story.slug}
                hashtags={story["seo"]["meta-keywords"] ? hashtags.join(",") : ""}
                color="#000"
                sticky
              />
            </div>
            <div className="voice-article" styleName="story-container">
              <div styleName="story-header">
                <StoryHeader story={story} />
              </div>
                <div styleName="story-body">
                  <div>

                    <article>
                      <div itemProp="articleBody">
                        {story.cards.map((card, index) => (
                          <React.Fragment key={index}>
                            <StoryCard key={card.id} card={card} story={story} />
                          </React.Fragment>
                        ))}
                      </div>
                      {<span className="article_end" styleName="article_end_style"></span>}
                      <SocialShareBottom story={story} />
                    </article>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

NativeAdStory.propTypes = {
  story: PT.object,
  isActive: PT.bool
};

export { NativeAdStory };
